import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import style from "./index.module.scss";
import CloseIcon from "../../shared/icons/CloseIcon";
import { toast } from "react-toastify";
import CopyIconNew from "../../shared/icons/CopyIconNew";

const InviteLinkModal = ({ isOpen, onClose, inviteUrl, driverName, expiry = "" }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const formatExpiryDate = (expiryString) => {
    if (!expiryString) return "";

    try {
      const date = new Date(expiryString);
      return date.toLocaleString("ru-RU", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch (error) {
      console.error("Error formatting date:", error);
      return "";
    }
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(inviteUrl);
      setCopied(true);
      toast.success(t("driversCreatePage.copied"));
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      const textArea = document.createElement("textarea");
      textArea.value = inviteUrl;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      setCopied(true);
      toast.success(t("driversCreatePage.copied"));
      setTimeout(() => setCopied(false), 2000);
    }
  };

  if (!isOpen) return null;

  const formattedExpiry = formatExpiryDate(expiry);

  return (
    <div className={style.modal_overlay}>
      <div className={style.modal_content}>
        <div className={style.modal_header}>
          <h2 className={style.modal_title}>{t("driversCreatePage.driverRegistrationLink")}</h2>
          <button onClick={onClose} className={style.modal_close}>
            <CloseIcon />
          </button>
        </div>

        <div className={style.modal_body}>
          <p className={style.modal_text}>
            {t("driversCreatePage.driverRegistrationInstruction", { driverName })}
          </p>

          <div className={style.link_container}>
            <div className={style.link_display}>
              <span className={style.link_text}>{inviteUrl}</span>
            </div>

            <button
              onClick={copyToClipboard}
              className={cn(style.copy_button, {
                [style.copy_button_success]: copied,
              })}
            >
              <CopyIconNew stroke="#fff" />
              <span>{copied ? t("driversCreatePage.copied") : t("orderInfo.ordersInfoHeader.copy")}</span>
            </button>
          </div>

          {formattedExpiry && (
            <div className={style.expiry_info}>
              <p className={style.expiry_text}>
                {t("driversCreatePage.linkExpiresAt")}: {formattedExpiry}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InviteLinkModal;
